
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.734 10.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.734 1.234L10.5 0 5.25 5.25l5.25 5.25 1.234-1.234L7.726 5.25l4.007-4.016m-5.25 0L5.25 0 0 5.25l2.787 2.787L5.25 10.5l1.234-1.234L2.476 5.25z","fill":"#fff"}})])
          )
        }
      }
    